import { createReducer } from 'redux-act';
import * as actions from '#app/actions/dividend';
import type { DividendFormPayload } from '#app/actions/dividend';

export interface DividendState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: DividendState = {
  modalVisible: false,
  form: {},
};

const setDividendModalVisible = (state: DividendState, bool: boolean): DividendState => ({
  ...state,
  modalVisible: bool,
});

const setDividendForm = (state: DividendState, form: DividendFormPayload): DividendState => ({
  ...state,
  form: form ?? {},
});

const closeDividendForm = (state: DividendState): DividendState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<DividendState>(
  {
    [actions.setDividendModalVisible.getType()]: setDividendModalVisible,
    [actions.setDividendForm.getType()]: setDividendForm,
    [actions.closeDividendForm.getType()]: closeDividendForm,
  },
  initialState
);
